import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectorRef
} from "@angular/core";
import { IonicApp, IonicModule } from "ionic-angular";
import { MyApp } from "./app.component";
import { Http } from "@angular/http";
import { GeneratePage } from "../pages/generate/generate";
import { NotificationsPage } from "../pages/notifications/notifications";
import { ProfilePage } from "../pages/profile/profile";
import { WalkthroughPage } from "../pages/walkthrough/walkthrough";
import { SettingsPage } from "../pages/settings/settings";
import { TermsOfServicePage } from "../pages/terms-of-service/terms-of-service";
import { PrivacyPolicyPage } from "../pages/privacy-policy/privacy-policy";
import { FormValidationsPage } from "../pages/form-validations/form-validations";
import { PreloadImage } from "../components/preload-image/preload-image";
import { BackgroundImage } from "../components/background-image/background-image";
import { ShowHideContainer } from "../components/show-hide-password/show-hide-container";
import { ShowHideInput } from "../components/show-hide-password/show-hide-input";
import { ColorRadio } from "../components/color-radio/color-radio";
import { CounterInput } from "../components/counter-input/counter-input";
import { Rating } from "../components/rating/rating";
import { ProfileService } from "../pages/profile/profile.service";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";
import { SplashScreen } from "@ionic-native/splash-screen";
import { NativeStorage } from "@ionic-native/native-storage";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { Keyboard } from "@ionic-native/keyboard";
import { AppRate } from "@ionic-native/app-rate";
import { EmailComposer } from "@ionic-native/email-composer";
import { ValidatorsModule } from "../components/validators/validators.module";
import { LanguageService } from "../providers/language/language.service";
//Firebase Stuff
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireModule } from "angularfire2";
import { AngularFireDatabaseModule } from "angularfire2/database";
import {
  AngularFirestoreModule,
  AngularFirestore
} from "angularfire2/firestore";
import { AuthProvider } from "../providers/auth/auth";
import { UserProvider } from "../providers/user/user";
import { ImghandlerProvider } from "../providers/imghandler/imghandler";
import { File } from "@ionic-native/file";
import { FileChooser } from "@ionic-native/file-chooser";
import { FilePath } from "@ionic-native/file-path";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { Camera } from "@ionic-native/camera";
import { HeaderColor } from "@ionic-native/header-color";
import { Geolocation } from "@ionic-native/geolocation";
import { SettingsProvider } from "../providers/settings/settings";
import { LaunchNavigator } from "@ionic-native/launch-navigator";
import { NgxQRCodeModule } from "ngx-qrcode2";
import { Diagnostic } from "@ionic-native/diagnostic";
import { Network } from "@ionic-native/network";
import { FileTransfer } from "@ionic-native/file-transfer";
import { AlertProvider } from "../providers/alert/alert";
import { ToastProvider } from "../providers/toast/toast";
import { LoadingProvider } from "../providers/loading/loading";
import { NetworkProvider } from "../providers/network/network";
import { Environment } from "../environment/environment";
import { TimelinePage } from "../pages/timeline/timeline";
import { IonicStorageModule } from "@ionic/storage";
import { SuperTabsModule } from "ionic2-super-tabs";
import { GooglePlus } from "@ionic-native/google-plus";
import { PaymentServiceProvider } from "../providers/payment-service/payment-service";
import { ContactCardPage } from "../pages/contact-card/contact-card";
import { CallNumber } from "@ionic-native/call-number";
import { ThreeDeeTouch } from "@ionic-native/three-dee-touch";
import { FirestoreProvider } from "../providers/firestore/firestore";
import { NativePageTransitions } from "@ionic-native/native-page-transitions";
import { Pro } from "@ionic/pro";
import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { IonicErrorHandler } from "ionic-angular";
import { ValidateProvider } from "../providers/validate/validate";
import { ChartsModule } from "ng2-charts";
import { HttpClientModule } from "@angular/common/http";
import { PhotoViewer } from "@ionic-native/photo-viewer";
import { Device } from "@ionic-native/device";
import { Screenshot } from "@ionic-native/screenshot";
import { FcmProvider } from '../providers/fcm/fcm';
import { Firebase } from '@ionic-native/firebase';
import { DocusignProvider } from '../providers/docusign/docusign';

// @Injectable()
// export class MyErrorHandler implements ErrorHandler {
//   ionicErrorHandler: IonicErrorHandler;

//   constructor(injector: Injector) {
//     try {
//       this.ionicErrorHandler = injector.get(IonicErrorHandler);
//     } catch(e) {
//       // Unable to get the IonicErrorHandler provider, ensure
//       // IonicErrorHandler has been added to the providers list below
//     }
//   }

//   handleError(err: any): void {
//     Pro.monitoring.handleNewError(err);
//     // Remove this if you want to disable Ionic's auto exception handling
//     // in development mode.
//     this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);
//   }
// }
@NgModule({
  declarations: [
    MyApp,
    ProfilePage,
    WalkthroughPage,
    SettingsPage,
    TermsOfServicePage,
    PrivacyPolicyPage,
    PreloadImage,
    BackgroundImage,
    ShowHideContainer,
    ShowHideInput,
    ColorRadio,
    CounterInput,
    Rating,
    GeneratePage,
    TimelinePage,
    ContactCardPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {
      modalEnter: "modal-slide-in",
      modalLeave: "modal-slide-out",
      pageTransition: "ios-transition",
      swipeBackEnabled: false,
      tabsHideOnSubPages: true,
      mode: "ios",
      // scrollAssist: false,
      // autoFocusAssist: false
    }),
    SuperTabsModule.forRoot(),
    ValidatorsModule,
    AngularFireModule.initializeApp(Environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    NgxQRCodeModule,
    IonicStorageModule.forRoot(),
    ChartsModule,
    HttpClientModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ProfilePage,
    WalkthroughPage,
    SettingsPage,
    TermsOfServicePage,
    PrivacyPolicyPage,
    GeneratePage,
    TimelinePage,
    ContactCardPage
  ],
  providers: [
    ProfileService,
    LanguageService,
    SplashScreen,
    NativeStorage,
    NgxQRCodeModule,
    InAppBrowser,
    Keyboard,
    AppRate,
    EmailComposer,
    AuthProvider,
    AngularFireAuth,
    UserProvider,
    ImghandlerProvider,
    FileChooser,
    FilePath,
    BarcodeScanner,
    Camera,
    Keyboard,
    HeaderColor,
    File,
    Geolocation,
    SettingsProvider,
    LaunchNavigator,
    Diagnostic,
    Network,
    FileTransfer,
    AlertProvider,
    ToastProvider,
    LoadingProvider,
    NetworkProvider,
    GooglePlus,
    PaymentServiceProvider,
    CallNumber,
    ThreeDeeTouch,
    FirestoreProvider,
    NativePageTransitions,
    IonicErrorHandler,
    ValidateProvider,
    PhotoViewer,
    Device,
    Screenshot,
    FcmProvider,
    Firebase,
    DocusignProvider,
    // IonicErrorHandler,
    // [{ provide: ErrorHandler, useClass: MyErrorHandler }]
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: []
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts